import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, Channel, ChannelService } from 'lib-trend-core';
import { takeUntil } from 'rxjs';


@Component({
    selector: 'channel-redirect-instagram-component',
    templateUrl: 'channel-redirect-instagram.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChannelRedirectInstagramComponent extends AbstractComponent implements OnInit {

  constructor(
    public injector: Injector,
    public dialog: MatDialog,
    private channelService: ChannelService,
  ) {
    super(injector);
  }

  ngOnInit() {

    // A refused or cancelled authorization comes back on the query string, not the fragment —
    // without this branch the user is left on a blank redirect page with no way back.
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const reason = params['error_description'] ?? params['error'];
        if (!!reason) {
          this.alertService.error(reason);
          this.goBackToChannel(params['state']);
        }
      });

    this.route.fragment.subscribe(async fragment => {
      if (fragment) {
        const params = new URLSearchParams(fragment);
        const accessToken = params.get('access_token');
        // `state` carries the channel being reconnected (set by buildMetaOAuthUrl). When present the
        // API refreshes that channel's connection data instead of connecting every authorized page,
        // so the channel — and its conversation history — is kept.
        const idChannel = params.get('state') ?? undefined;
        this.channelService.createInstagramChannel(accessToken, idChannel).subscribe({
          next: (channels: Array<Channel>) => {
            this.alertService.success(!!idChannel
              ? this.t('channel.redirectInstagram.channelReconnectedSuccess')
              : this.t('channel.redirectInstagram.channelsCreatedSuccess'));
            this.goBackToChannel(idChannel);
          },
          error: (err) => {
            this.goBackToChannel(idChannel);
            this.alertService.error(err.error?.message ?? this.t('channel.redirectInstagram.channelsCreateError'));
          }
        });
      }
    });
  }

  /** Back to the reconnected channel when there is one, to the channel list otherwise. */
  private goBackToChannel(idChannel?: string): void {
    this.router.navigate(!!idChannel ? ['/channel/view', idChannel] : ['/channel']);
  }

}
